import { render, staticRenderFns } from "./crudOrders.vue?vue&type=template&id=0dbce942&scoped=true"
import script from "./crudOrders.vue?vue&type=script&lang=js"
export * from "./crudOrders.vue?vue&type=script&lang=js"
import style0 from "./crudOrders.vue?vue&type=style&index=0&id=0dbce942&prod&lang=css"
import style1 from "./crudOrders.vue?vue&type=style&index=1&id=0dbce942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbce942",
  null
  
)

export default component.exports